import { render, staticRenderFns } from "./BidPrice.vue?vue&type=template&id=486a7851&scoped=true"
import script from "./BidPrice.vue?vue&type=script&lang=js"
export * from "./BidPrice.vue?vue&type=script&lang=js"
import style0 from "./BidPrice.vue?vue&type=style&index=0&id=486a7851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a7851",
  null
  
)

export default component.exports